import axiosInstance from "../../axiosInstance";

// const base = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
// const BASE_URL = `${base}/hrm/documents`;

const BASE_URL = "/hrm/documents";

/**
 * 📄 Lấy danh sách tất cả tài liệu
 */
export const getAllDocuments = async (filters = {}) => {
  try {
    const res = await axiosInstance.get(BASE_URL, { params: filters });
    return res.data;
  } catch (error) {
    console.error("Lỗi khi tải danh sách tài liệu:", error);
    throw error;
  }
};

/**
 * 🔍 Lấy tài liệu theo trạng thái & cấp độ (filter)
 */
export const getDocumentsByStatusAndLevel = async ({ status, level }) => {
  try {
    const params = new URLSearchParams();
    if (status) params.append("status", status);
    if (level) params.append("level", level);

    const res = await axiosInstance.get(`${BASE_URL}/filter?${params.toString()}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy tài liệu theo status và level:", error);
    throw error;
  }
};

/**
 * ➕ Tạo mới tài liệu
 */
export const createDocument = async (data) => {
  try {
    const res = await axiosInstance.post(BASE_URL, data);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi tạo tài liệu:", error);
    throw error;
  }
};

/**
 * ✏️ Cập nhật tài liệu
 */
export const updateDocument = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật tài liệu:", error);
    throw error;
  }
};

/**
 * 🗑️ Xóa tài liệu
 */
export const deleteDocument = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi xóa tài liệu:", error);
    throw error;
  }
};

/**
 * 📁 Upload file tài liệu (GCS/Drive)
 */
export const uploadDocument = async (formData) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.error("Lỗi khi upload tài liệu:", error);
    throw error;
  }
};

/**
 * 👁️ Xem tài liệu (trả về file blob)
 */
export const viewDocument = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}/view`, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    console.error("Lỗi khi xem tài liệu:", error);
    throw error;
  }
};

/**
 * ⬇️ Tải tài liệu
 */
export const downloadDocument = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}/download`, {
      responseType: "blob",
    });
    return res;
  } catch (error) {
    console.error("Lỗi khi tải tài liệu:", error);
    throw error;
  }
};

/**
 * 🔎 Lấy chi tiết 1 tài liệu theo ID
 */
export const getDocumentById = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy chi tiết tài liệu:", error);
    throw error;
  }
};

/**
 * 🏷️ Lấy danh sách nhóm tài liệu
 */
export const getDocumentGroups = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/document-groups`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi tải danh sách nhóm tài liệu:", error);
    throw error;
  }
};
